import { ShieldCheck, Award, BadgeCheck, Globe2 } from "lucide-react";
import { useReveal } from "../hooks/useReveal";

const CERTS = [
    {
        icon: Globe2,
        name: "IEC",
        sub: "Import Export Code",
        desc: "Issued by DGFT, Govt. of India",
    },
    {
        icon: ShieldCheck,
        name: "FSSAI",
        sub: "Food Safety",
        desc: "Licensed food business operator",
    },
    {
        icon: Award,
        name: "Spices Board",
        sub: "Registered Exporter",
        desc: "Govt. of India · Min. of Commerce",
    },
    {
        icon: BadgeCheck,
        name: "ISO Standards",
        sub: "Quality processes",
        desc: "Aligned with ISO 22000 / HACCP practices",
    },
];

export default function Certifications() {
    const ref = useReveal();
    return (
        <section
            id="certs"
            data-testid="certs-section"
            className="bg-white py-24 sm:py-32"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
                <div ref={ref} className="reveal mb-12 grid gap-8 lg:grid-cols-12">
                    <div className="lg:col-span-7">
                        <span className="text-xs uppercase tracking-[0.22em] text-brand-red">
                            Certifications
                        </span>
                        <h2 className="mt-3 font-display text-4xl font-bold tracking-[-0.025em] sm:text-6xl">
                            Compliance you can ship with.
                        </h2>
                    </div>
                    <p className="text-ink-muted lg:col-span-5 lg:pt-3">
                        RP Traders is registered, audited and verified by the
                        relevant Indian export authorities. We provide
                        certificates of origin, phytosanitary, fumigation and
                        third-party lab reports with every shipment.
                    </p>
                </div>

                <div className="grid gap-px overflow-hidden rounded-3xl border border-hairline bg-hairline sm:grid-cols-2 lg:grid-cols-4">
                    {CERTS.map((c) => (
                        <div
                            key={c.name}
                            data-testid={`cert-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
                            className="bg-white p-7 transition-colors hover:bg-brand-turmeric/10"
                        >
                            <span className="grid h-12 w-12 place-items-center rounded-2xl bg-ink text-white">
                                <c.icon className="h-6 w-6" />
                            </span>
                            <div className="mt-5 font-display text-xl font-bold tracking-tight">
                                {c.name}
                            </div>
                            <div className="text-xs uppercase tracking-[0.18em] text-brand-red">
                                {c.sub}
                            </div>
                            <p className="mt-3 text-sm text-ink-muted">
                                {c.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
